import React from "react";
import { useAuth } from "../AuthContext";
import "./ImpersonationBanner.css";

export default function ImpersonationBanner() {
  const { impersonating, stopImpersonating } = useAuth();
  if (!impersonating) return null;

  return (
    <div className="impersonation-banner">
      <span className="banner-icon">👁️</span>
      <span className="banner-text">
        You are viewing as <strong>{impersonating.full_name}</strong>
        <span className="banner-role">({impersonating.role.replace("_", " ")})</span>
      </span>
      <button className="banner-stop-btn" onClick={stopImpersonating}>
        ✕ Return to Admin View
      </button>
    </div>
  );
}
